/**
 * Constants for Invite Users page (Step 2).
 * Single source of truth: copy, wizard, toasts, and error messages.
 * Open/Closed: add new copy or messages here without changing components.
 */

export const PAGE_COPY = {
  TITLE: 'Invite Users',
};

export const WIZARD_STEP = {
  CURRENT: 2,
  TOTAL: 3,
  NAME: 'Invite Users',
  DISABLED_REASON: 'Invite at least one user to continue',
};

/** User-facing error and success messages */
export const ERROR_MESSAGES = {
  INVITE_USER: 'Failed to invite user. Please try again',
  UPDATE_USER: 'Failed to update user. Please try again',
  DELETE_USER: 'Failed to delete user',
  DELETE_USERS: 'Failed to delete users',
  LOAD_USER: 'Failed to load user information',
  INVALID_RESPONSE: 'Invalid response from server',
  CANNOT_DELETE_PRIMARY_ADMIN: 'Cannot delete the Primary Organization Admin',
  CANNOT_DELETE_SOME_USERS: 'Cannot delete Primary Organization Admin users',
};

export const TOAST_CONFIG = {
  TITLE_SUCCESS: 'Success',
  TITLE_ERROR: 'Error',
  TITLE_CANNOT_DELETE: 'Cannot Delete User',
  TITLE_CANNOT_DELETE_SOME: 'Cannot Delete Some Users',
};

/**
 * Build confirm message for bulk delete.
 * @param {number} count
 * @returns {string}
 */
export function getConfirmDeleteMessage(count) {
  const suffix = count !== 1 ? 's' : '';
  return `Are you sure you want to delete ${count} user${suffix}?`;
}

/**
 * Build success copy for single user invite.
 * @param {string} email
 * @returns {string}
 */
export function getInviteSuccessCopy(email) {
  return `User invited successfully. Invitation sent to ${email}`;
}
